// @flow

import type { PendingIncomingPayment } from './types';

// the backend sends the expiration in the indonesian timezone (WIB, no daylight saving) without a timezone indicator
const QRIS_TIMEZONE_OFFSET = '+07:00';
const RE_EXPIRATION_DATE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})$/;

function getExpirationDate(incomingPayment: PendingIncomingPayment): ?string {
  return incomingPayment['qris']?.['expiration_date'];
}

function parseExpirationDate(incomingPayment: PendingIncomingPayment): ?$ReadOnlyArray<string> {
  const expirationDate = getExpirationDate(incomingPayment);

  return expirationDate ? RE_EXPIRATION_DATE.exec(expirationDate) : null;
}

export function getQrisExpirationTimestamp(incomingPayment: PendingIncomingPayment): ?number {
  const matchObj = parseExpirationDate(incomingPayment);

  if (!matchObj) {
    return null;
  }

  const [, year, month, day, hour, minutes, seconds] = matchObj;
  const timestamp = new Date(`${year}-${month}-${day}T${hour}:${minutes}:${seconds}${QRIS_TIMEZONE_OFFSET}`).getTime();

  return Number.isNaN(timestamp) ? null : timestamp;
}

export function getQrisExpirationDisplay(incomingPayment: PendingIncomingPayment): ?string {
  const matchObj = parseExpirationDate(incomingPayment);

  if (!matchObj || getQrisExpirationTimestamp(incomingPayment) === null) {
    return null;
  }

  const [, , month, day, hour, minutes] = matchObj;

  return `${day}/${month} - ${hour}:${minutes}`;
}
